<template>
  <div class="divider-component inner">
    <div class="line line-1" />
    <div class="line line-2" />
    <div class="line line-3" />
    <div class="line line-4" />
    <div class="line line-5" />
  </div>
</template>
<script>
  export default {
    name: 'divider-component',
  }
</script>
<style scoped lang="scss">
  .divider-component {
    margin: 20px auto;
  }
  .line {
    height: 10px;
    width: 100%;
  }
  .line-1 {
    background: $color-1;
  }
  .line-2 {
    background: $color-2;
  }
  .line-3 {
    background: $color-3;
  }
  .line-4 {
    background: $color-4;
  }
  .line-5 {
    height: 5px;
    margin-top: 5px;
    background: $color-5;
  }
</style>